export default __webpack_public_path__ + "static/media/storageUnit1-afterA-1440w.21fb70bd.png";